export default __webpack_public_path__ + "static/media/game_candy.cb9ec6c2.png";